var _defineProperty = require("/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
!function e(t, o, i) {
  function s(r, a) {
    if (!o[r]) {
      if (!t[r]) {
        var p = "function" == typeof require && require;
        if (!a && p) return p(r, !0);
        if (n) return n(r, !0);
        var c = new Error("Cannot find module '" + r + "'");
        throw c.code = "MODULE_NOT_FOUND", c;
      }
      var l = o[r] = {
        exports: {}
      };
      t[r][0].call(l.exports, function (e) {
        var o = t[r][1][e];
        return s(o ? o : e);
      }, l, l.exports, e, t, o, i);
    }
    return o[r].exports;
  }
  for (var n = "function" == typeof require && require, r = 0; r < i.length; r++) s(i[r]);
  return s;
}({
  1: [function (e, t, o) {
    var i = {},
      s = e("./config/Config.js"),
      n = function n(e, t, o) {
        return window.$ || window.jQuery || console.error("Feedback component needs jquery as dependency. Please be sure you included it before using this component."), e ? e.hasOwnProperty("sim") !== !1 && e.hasOwnProperty("survey") !== !1 ? (i = this, this.init(e, t, o), s.environment(this.env), this) : void console.error("Sim or Survey not defined. Make sure you are using correct case.") : (console.error("Sim or Survey not defined. Make sure you are using correct case."), !1);
      };
    t.exports = window.Feedback = n, Object.defineProperty(n, "app", {
      get: function get() {
        return i;
      }
    });
    var r = (e("./util/Binder.js"), e("./FeedbackPublicAPIS.js"));
    n.prototype = r;
  }, {
    "./FeedbackPublicAPIS.js": 3,
    "./config/Config.js": 12,
    "./util/Binder.js": 30
  }],
  2: [function (e, t, o) {
    var i = e("./Feedback.js"),
      s = e("./templates/PopUpCss.tpl"),
      n = e("./templates/PageCss.tpl"),
      r = e("./util/Template.js").tmpl,
      a = e("./config/Config.js").getConfig(),
      p = e("./util/Url.js").getUrl,
      c = e("./templates/TemplateHtml.tpl"),
      l = e("./templates/SubmitButton.tpl"),
      u = e("./apis/SubmitAnswer.js").submit;
    t.exports = function () {
      var e = function e() {};
      return e.prototype.appendInlineCSS = function () {
        var e = i.app.showAsPopup ? s : n;
        e = r(e, {
          smileyActiveUrl: p(a.smileyActiveUrl),
          heartActiveUrl: p(a.heartActiveUrl),
          starActiveUrl: p(a.starActiveUrl),
          smileyInactiveUrl: p(a.smileyInactiveUrl),
          heartInactiveUrl: p(a.heartInactiveUrl),
          starInactiveUrl: p(a.starInactiveUrl),
          fontUrl: p(a.fontUrl),
          mandatoryMessageBackgroundColor: i.app.mandatoryMessageBackgroundColor,
          mandatoryMessageFontColor: i.app.mandatoryMessageFontColor
        }), $("body").append(e);
      }, e.prototype.appendMainBody = function () {
        var e = r(c, {
          headerColor: i.app.headerColor,
          headerTitle: i.app.headerTitle,
          headerTitleColor: i.app.headerTitleColor,
          headerTitleFontSize: i.app.headerTitleFontSize,
          smileyActiveUrl: p(a.smileyActiveUrl),
          heartActiveUrl: p(a.heartActiveUrl),
          starActiveUrl: p(a.starActiveUrl),
          mandatoryMessage: i.app.mandatoryMessage,
          closeFeedbackButton: p(a.closeFeedbackButtonUrl),
          knolskapeLogoUrl: p(a.knolskapeLogoUrl)
        });
        $("body").append(e), i.app.showAsPopup || $("#fwc-closeFeedback").remove();
      }, e.prototype.appendQuestions = function () {
        $(".fwc-feedback-form-wrapper").append(i.app.questionsHTML);
      }, e.prototype.appendSubmitButton = function () {
        $(".popup").append(l);
      }, e.prototype.bindSubmitButtonClick = function (e) {
        $("body").on("click", "#fwc-submit", function () {
          for (var t = !0, o = [], s = -1, n = 0; n < e.length; n++) {
            var r;
            switch (+e[n].questionType) {
              case 1:
                $("input[name=questionID-" + e[n].questionID + "]:checked").data("optionid") || 0 !== +e[n].questionOptional ? ($("#error-" + e[n].questionID).addClass("hidden"), r = {
                  answer: $("input[name=questionID-" + e[n].questionID + "]:checked").data("optionid"),
                  questionID: e[n].questionID,
                  questionType: e[n].questionType
                }) : ($("#error-" + e[n].questionID).removeClass("hidden"), t = !1, s === -1 && (s = e[n].questionID)), o.push(r);
                break;
              case 2:
                var a = [];
                $("input[name=questionID-" + e[n].questionID + "]:checked").each(function () {
                  a.push($(this).data("optionid"));
                }), 0 === a.length && 0 === +e[n].questionOptional ? (t = !1, $("#error-" + e[n].questionID).removeClass("hidden"), s === -1 && (s = e[n].questionID)) : ($("#error-" + e[n].questionID).addClass("hidden"), r = {
                  answer: a,
                  questionID: e[n].questionID,
                  questionType: e[n].questionType
                }), o.push(r);
                break;
              case 3:
              case 5:
              case 6:
                i.app.ratingQuestionsObj[e[n].questionID].answer || 0 !== +e[n].questionOptional ? ($("#error-" + e[n].questionID).addClass("hidden"), r = i.app.ratingQuestionsObj[e[n].questionID]) : (t = !1, $("#error-" + e[n].questionID).removeClass("hidden"), s === -1 && (s = e[n].questionID)), o.push(r);
                break;
              case 4:
                $("#questionID-" + e[n].questionID + "-response").val() || 0 !== +e[n].questionOptional ? ($("#error-" + e[n].questionID).addClass("hidden"), r = {
                  answer: $("#questionID-" + e[n].questionID + "-response").val(),
                  questionID: e[n].questionID,
                  questionType: e[n].questionType
                }) : (t = !1, $("#error-" + e[n].questionID).removeClass("hidden"), s === -1 && (s = e[n].questionID)), o.push(r);
            }
          }
          t === !0 ? u(o).fail(function () {
            $("body").off("click", "#fwc-submit"), i.app.remove();
          }) : (console.log(s), $(".fwc-feedback-form-wrapper").animate({
            scrollTop: $("#fwc-questionID-" + s).position().top - $(".fwc-feedback-form").position().top
          }, "slow"));
        });
      }, new e();
    }();
  }, {
    "./Feedback.js": 1,
    "./apis/SubmitAnswer.js": 9,
    "./config/Config.js": 12,
    "./templates/PageCss.tpl": 22,
    "./templates/PopUpCss.tpl": 23,
    "./templates/SubmitButton.tpl": 28,
    "./templates/TemplateHtml.tpl": 29,
    "./util/Template.js": 32,
    "./util/Url.js": 34
  }],
  3: [function (e, t, o) {
    var i = e("./util/TypeChecker.js"),
      s = e("./apis/FetchServiceId.js"),
      n = e("./apis/FetchSurveyId.js"),
      r = e("./apis/GetQuestions.js"),
      a = e("./validators/AttributeValidator.js").isAttributeValid,
      p = e("./apis/SyncUser.js").sync,
      c = e("./Form.js"),
      l = e("./FeedbackComponentBuilder.js"),
      u = e("./templates/SimEndOverLay.tpl"),
      d = e("./templates/SimEndMsg.tpl"),
      f = e("./util/Template.js").tmpl,
      h = e("./templates/FeedbackDoneOverlay.tpl"),
      m = e("./templates/FeedbackDone.tpl"),
      g = e("./templates/FeedbackFetchIssueOverlay.tpl"),
      b = e("./templates/FeedbackIssue.tpl"),
      y = e("./util/Url.js").getUrl,
      v = e("./config/Config.js").getConfig();
    t.exports = {
      init: function init(e, t, o) {
        return this.set(e), i.areOfSameType(t, function () {}) && (this.onSuccessfulSubmit = t), i.areOfSameType(t, {}) && this.set(t), i.areOfSameType(o, {}) && this.set(o), this;
      },
      set: function set(e) {
        if (i.areOfSameType(e, {})) for (var t in e) a(t, e[t]) ? this[t] = e[t] : console.log(t + " is an invalid propery.");
        return this;
      },
      setCurrentUser: function setCurrentUser(e) {
        return isNaN(e) || (e = +e), this.set({
          simUserId: e
        }), this;
      },
      setCommonDbUser: function setCommonDbUser(e) {
        return isNaN(e) || (e = +e), this.set({
          uliId: e
        }), this;
      },
      setCommonDbGroup: function setCommonDbGroup(e) {
        return isNaN(e) || (e = +e), this.set({
          groupId: e
        }), this;
      },
      setAktivLearnCourse: function setAktivLearnCourse(e) {
        return isNaN(e) || (e = +e), this.set({
          courseId: e
        }), this;
      },
      setAktivLearnSection: function setAktivLearnSection(e) {
        return isNaN(e) || (e = +e), this.set({
          sectionId: e
        }), this;
      },
      setAktivLearnUser: function setAktivLearnUser(e) {
        return isNaN(e) || (e = +e), this.set({
          alUserId: e
        }), this;
      },
      setAktivLearnDomain: function setAktivLearnDomain(e) {
        return this.set({
          domain: e
        }), this;
      },
      setAktivLearnUserEmail: function setAktivLearnUserEmail(e) {
        return this.set({
          email: e
        }), this;
      },
      setAktivLearnCourseLabel: function setAktivLearnCourseLabel(e) {
        return this.set({
          courseLabel: e
        }), this;
      },
      setAktivLearnCourseName: function setAktivLearnCourseName(e) {
        return this.set({
          courseName: e
        }), this;
      },
      setAktivLearnUserFullName: function setAktivLearnUserFullName(e) {
        return this.set({
          aktivLearnUserFullName: e
        }), this;
      },
      setAktivLearnDetails: function setAktivLearnDetails(e) {
        return e.courseId && this.setAktivLearnCourse(e.courseId), e.sectionId && this.setAktivLearnSection(e.sectionId), e.alUserId && this.setAktivLearnUser(e.alUserId), e.domain && this.setAktivLearnDomain(e.domain), e.email && this.setAktivLearnUserEmail(e.email), e.courseLabel && this.setAktivLearnCourseLabel(e.courseLabel), e.courseName && this.setAktivLearnCourseName(e.courseName), e.fullName && this.setAktivLearnUserFullName(e.fullName), this;
      },
      setCommonDBDetails: function setCommonDBDetails(e) {
        return e.uliId && this.setCommonDbUser(e.uliId), e.groupId && this.setCommonDbGroup(e.groupId), this;
      },
      isSimIdSurveyId: function isSimIdSurveyId() {
        return !(!this.hasOwnProperty("simId") || !this.hasOwnProperty("surveyId"));
      },
      showFeedbackForm: function showFeedbackForm() {
        if (this.isFeedbackFetchedFlag === !0 && this.isFeedbackCompletedFlag === !1 && this.anyServiceFailed === !1) {
          l.appendInlineCSS(), l.appendMainBody(), l.appendQuestions(), l.appendSubmitButton(), l.bindSubmitButtonClick(this.questionsJSON.surveyDetails);
          var e = this;
          $("#fwc-closeFeedback").click(function (t) {
            1 == e.isSurveyMandatory ? 1 == e.isFeedbackCompleted() ? (e.remove(), e.onSuccessfulSubmit()) : e.showMandatoryMessage() : (e.remove(), e.onSuccessfulSubmit());
          }), $(".prevent-drag").bind("dragstart", function () {
            return !1;
          });
        } else this.remove(), console.log("Failed to show Feedback form!");
        return this;
      },
      isCompleted: function isCompleted() {
        return this.isFeedbackCompletedFlag;
      },
      remove: function remove() {
        console.log("removing component"), $("body").off("click", "#fwc-submit"), $("#fwc-feedbackComponent").remove();
      },
      subTitleHighlight: function subTitleHighlight() {
        $("#fwc-feedbackSecondaryHeading").css("background-color", this.headerSubTitleHighlightColor), setTimeout(function () {
          $("#fwc-feedbackSecondaryHeading").css("background-color", "");
        }, this.headerSubTitleHighlightTimeout);
      },
      onSuccessfulSubmit: function onSuccessfulSubmit() {
        console.log("Callback not defined");
      },
      onReady: function onReady(e) {
        var t = this;
        $(document).ready(function () {
          console.log("Setting on ready func"), t.set({
            onReadyFun: e
          }), t.isFormPrepared && (console.log("form is already perpared"), t.onReadyFun());
        });
      },
      prepareForm: function prepareForm() {
        self = this, $.when(s.fetch(), n.fetch()).then(function () {
          p().then(function () {
            r.fetch().then(function () {
              self.prepareFeedbackForm(), self.isFormPrepared = !0, self.onReadyFun();
            }).fail(function () {
              self.onReadyFun();
            });
          }).fail(function () {
            self.onReadyFun();
          });
        }).fail(function () {
          self.onReadyFun();
        });
      },
      prepareFeedbackForm: function prepareFeedbackForm() {
        if (console.log("prepareFeedbackForm is called"), this.anyServiceFailed === !1 && this.isSimIdSurveyId()) if (this.isCompleted() === !1) {
          if (0 == this.anyServiceFailed) {
            var e = c.prepareQuestionsHTML(this.questionsJSON.surveyDetails);
            e.length > 0 && this.set({
              isFeedbackFetchedFlag: !0,
              questionsHTML: e,
              isFeedbackCompletedFlag: !1
            });
          }
        } else this.set({
          isFeedbackFetchedFlag: !1
        });
      },
      isFeedbackCompleted: function isFeedbackCompleted() {
        return this.isFeedbackCompletedFlag;
      },
      isFeedbackFetched: function isFeedbackFetched() {
        return this.isFeedbackFetchedFlag;
      },
      showPopupWithFeedback: function showPopupWithFeedback() {
        if (this.isFeedbackFetchedFlag === !0 && this.isFeedbackCompletedFlag === !1 && this.anyServiceFailed === !1) {
          $("body").append(u);
          var e = this;
          $(".fwc-sim-end-msg-container").hide().append(f(d, {
            popupHeading: e.popupHeading,
            popupSubHeading: e.popupSubHeading
          })).fadeIn(1e3);
          var e = this;
          setTimeout(function () {
            $(".fwc-sim-end-popup").remove(), e.showFeedbackForm();
          }, this.popupTimeout);
        } else this.remove(), console.log("Failed to show popup feedback.");
      },
      alreadyFeedbackGivenPopup: function alreadyFeedbackGivenPopup() {
        $("body").append(h);
        var e = this;
        $(".fwc-feedback-already-done-overlay").hide().append(f(m, {
          feedbackDoneHeading: e.feedbackDoneHeading,
          feedbackDoneSubHeading: e.feedbackDoneSubHeading,
          simleyResponseUrl: y(v.smileyResponseUrl)
        })).fadeIn(500);
        var e = this;
        setTimeout(function () {
          e.showAsPopup && e.showAsPopup && $(".fwc-feedback-already-done-overlay").remove();
        }, this.feedbackAlreadyGivenPopupTimeout);
      },
      feedbackFetchIssue: function feedbackFetchIssue() {
        $("body").append(g);
        var e = this;
        $(".fwc-feedback-fetch-issue-overlay").hide().append(f(b, {
          feedbackFetchIssueHeading: e.feedbackFetchIssueHeading,
          smileyErrorUrl: y(v.smileyErrorUrl)
        })).fadeIn(100);
        var e = this;
        setTimeout(function () {
          e.showAsPopup && e.showAsPopup && $(".fwc-feedback-fetch-issue-overlay").remove();
        }, this.feedbackFetchIssuePopupTimeout);
      },
      hasAnyServiceFalied: function hasAnyServiceFalied() {
        return this.anyServiceFailed;
      },
      showMandatoryMessage: function showMandatoryMessage() {
        $("#fwc-mandatory-message").slideDown("fast", function () {
          setTimeout(function () {
            $("#fwc-mandatory-message").slideUp("slow");
          }, 2e3);
        });
      },
      submitFailed: function submitFailed() {
        return this.submitFailedFlag;
      },
      env: "test",
      headerColor: "#4C4439",
      headerTitle: "Feedback",
      headerTitleColor: "#FFFFFF",
      headerTitleFontSize: "45px",
      isFeedbackFetchedFlag: !1,
      isFeedbackCompletedFlag: !1,
      popupHeading: "Your report is being downloaded...",
      popupSubHeading: "Meanwhile, please provide us with your valuable feedback.",
      popupTimeout: 6e3,
      feedbackDoneHeading: "Thank you",
      feedbackDoneSubHeading: "You have already recorded your response.",
      feedbackFetchIssueHeading: "Error fetching the feedback",
      feedbackAlreadyGivenPopupTimeout: 2e3,
      feedbackFetchIssuePopupTimeout: 2e3,
      anyServiceFailed: !1,
      isSurveyMandatory: !1,
      mandatoryMessage: "Please, fill out the form.",
      mandatoryMessageFontColor: "#ffffcc",
      mandatoryMessageBackgroundColor: "#990000",
      submitFailedFlag: !1,
      isFormPrepared: !1,
      onReadyFun: function onReadyFun() {},
      showAsPopup: !0
    };
  }, {
    "./FeedbackComponentBuilder.js": 2,
    "./Form.js": 4,
    "./apis/FetchServiceId.js": 6,
    "./apis/FetchSurveyId.js": 7,
    "./apis/GetQuestions.js": 8,
    "./apis/SyncUser.js": 10,
    "./config/Config.js": 12,
    "./templates/FeedbackDone.tpl": 17,
    "./templates/FeedbackDoneOverlay.tpl": 18,
    "./templates/FeedbackFetchIssueOverlay.tpl": 19,
    "./templates/FeedbackIssue.tpl": 20,
    "./templates/SimEndMsg.tpl": 25,
    "./templates/SimEndOverLay.tpl": 26,
    "./util/Template.js": 32,
    "./util/TypeChecker.js": 33,
    "./util/Url.js": 34,
    "./validators/AttributeValidator.js": 35
  }],
  4: [function (e, t, o) {
    var i = e("./Feedback.js"),
      s = e("./util/Template.js").tmpl,
      n = e("./templates/Rate.tpl"),
      r = e("./templates/SingleAns.tpl"),
      a = e("./templates/MultipleAns.tpl"),
      p = e("./templates/CommentBased.tpl"),
      c = e("./config/Config.js").getConfig(),
      l = e("./util/Url.js").getUrl;
    t.exports = function () {
      var e = function e() {
          this.clickFunction = bind(this.clickFunction, this), this.addClasses = bind(this.addClasses, this), this.prepareQuestionsHTML = bind(this.prepareQuestionsHTML, this), this.prepareFeedbackForm = bind(this.prepareFeedbackForm, this);
        },
        t = $('<div class="fwc-feedback-form"> </div>');
      return e.prototype.addClasses = function (e, t, o, i) {
        for (var s = 1; s <= 5; s++) $("#rating" + s + "-" + o).removeClass(t), $("#rating" + s + "-" + o).removeClass(e), s <= i ? $("#rating" + s + "-" + o).addClass(e) : $("#rating" + s + "-" + o).addClass(t);
      }, e.prototype.clickFunction = function (e) {
        switch (i.app.ratingQuestionsObj || (i.app.ratingQuestionsObj = {}), i.app.ratingQuestionsObj[e.data.questionID].answer = e.data.rating, +e.data.questionType) {
          case 3:
            this.addClasses("starActive", "star", e.data.questionID, e.data.rating);
            break;
          case 5:
            this.addClasses("heartActive", "heart", e.data.questionID, e.data.rating);
            break;
          case 6:
            this.addClasses("smileyActive", "smiley", e.data.questionID, e.data.rating);
        }
      }, e.prototype.prepareQuestionsHTML = function (e) {
        i.app.ratingQuestionsObj || (i.app.ratingQuestionsObj = {}), e = e.sort(function (e, t) {
          return null != e.questionPosition && null != t.questionPosition ? +e.questionPosition - +t.questionPosition : 0;
        });
        for (var o = 0; o < e.length; o++) {
          e[o].qNo = o + 1;
          var u;
          switch (+e[o].questionType) {
            case 1:
              u = s(r, e[o]), t.append(u);
              break;
            case 2:
              u = s(a, e[o]), t.append(u);
              break;
            case 3:
            case 5:
            case 6:
              e[o].transparentUrl = l(c.transparentUrl), u = s(n, e[o]), t.append(u);
              for (var d = 0; d < 5; d++) $("body").on("click", "#rating" + (d + 1) + "-" + e[o].questionID, {
                rating: d + 1,
                questionType: e[o].questionType,
                questionID: e[o].questionID
              }, this.clickFunction);
              i.app.ratingQuestionsObj[e[o].questionID] = {
                answer: "",
                questionType: e[o].questionType,
                questionID: e[o].questionID
              };
              break;
            case 4:
              u = s(p, e[o]), t.append(u);
          }
        }
        return t[0].outerHTML;
      }, e.prototype.prepareFeedbackForm = function () {
        if (0 == Feedback.app.anyServiceFailed) {
          var e = this.prepareQuestionsHTML(Feedback.app.questionsJSON.surveyDetails);
          e.length > 0 && Feedback.app.set({
            isFeedbackFetchedFlag: !0,
            questionsHTML: e,
            isFeedbackCompletedFlag: !1
          });
        } else Feedback.app.set({
          isFeedbackFetchedFlag: !1
        });
      }, new e();
    }();
  }, {
    "./Feedback.js": 1,
    "./config/Config.js": 12,
    "./templates/CommentBased.tpl": 16,
    "./templates/MultipleAns.tpl": 21,
    "./templates/Rate.tpl": 24,
    "./templates/SingleAns.tpl": 27,
    "./util/Template.js": 32,
    "./util/Url.js": 34
  }],
  5: [function (e, t, o) {
    var i = e("../config/Config.js").getConfig();
    t.exports = function () {
      var t, o;
      o = e("../util/Promise.js").getPromiseFun;
      var s = !1,
        n = function n() {
          s || ($.ajaxSetup({
            cache: !1
          }), s = !0);
        };
      return new (t = function () {
        function e() {}
        var t;
        return t = function t(e, _t, o) {
          return n(), $.ajax(i.apiBaseUrl + e, {
            type: _t,
            dataType: "json",
            headers: {
              "X-CSRF-Token": $("body").data("csrftoken")
            },
            data: JSON.stringify(o.payload),
            success: function success(e) {
              return null != o && "function" == typeof o.success ? o.success(e) : void 0;
            },
            error: function error(e) {
              var t, i, s;
              if (t = null != e && null != (i = e.responseJSON) && null != (s = i.error) ? s.message : void 0) return null != o && "function" == typeof o.error ? o.error(t) : void 0;
            }
          });
        }, e.prototype.post = function (e, o) {
          return n(), t(e, "post", o);
        }, e.prototype.put = function (e, o) {
          return n(), t(e, "put", o);
        }, e.prototype.get = function (e, t) {
          return n(), $.ajax(i.apiBaseUrl + e, {
            type: "get",
            dataType: "json",
            headers: {
              "X-CSRF-Token": $("body").data("csrftoken")
            },
            success: function success(e) {
              return null != t && "function" == typeof t.success ? t.success(e) : void 0;
            },
            error: function error(e) {
              var o, i, s;
              return o = "Error occured while requesting", o = null != e && null != (i = e.responseJSON) && null != (s = i.error) ? s.message : void 0, null != t && "function" == typeof t.error ? t.error(o) : void 0;
            }
          });
        }, e.prototype["delete"] = function (e, t) {
          return n(), $.ajax(i.apiBaseUrl + e, {
            type: "delete",
            headers: {
              "X-CSRF-Token": $("body").data("csrftoken")
            },
            dataType: "json",
            data: JSON.stringify(t.payload),
            success: function success(e) {
              return null != t && "function" == typeof t.success ? t.success(e) : void 0;
            },
            error: function error(e) {
              var o, i, s;
              return o = "Error occured while requesting", o = null != e && null != (i = e.responseJSON) && null != (s = i.error) ? s.message : void 0, null != t && "function" == typeof t.error ? t.error(o) : void 0;
            }
          });
        }, e.prototype.setCache = function (e, t) {
          return window.sessionStorage.setItem(e, JSON.stringify(t));
        }, e.prototype.clearCache = function (e) {
          return window.sessionStorage.removeItem(e);
        }, e.prototype.call = function (e) {
          return o(function (e) {
            var t, o, i, s, n, r, a;
            return r = e.type.toLowerCase(), a = e.url.trim(), t = !!e.cache && e.cache, n = function n(o) {
              return t && window.sessionStorage.setItem(a, JSON.stringify(o)), "function" == typeof e.success ? e.success(o) : void 0;
            }, i = function i(t) {
              var o, i, s;
              return o = "Error occured while requesting", o = null != t && null != (i = t.responseJSON) && null != (s = i.error) ? s.message : void 0, "function" == typeof e.error ? e.error(o) : void 0;
            }, !r || "delete" !== r && "get" !== r && "put" !== r && "post" !== r ? "function" == typeof e.error ? e.error("Unknown type while calling to the server") : void 0 : (s = !0, t && (window.sessionStorage ? (o = JSON.parse(window.sessionStorage.getItem(a))) && (s = !1) : console.warn("This browser does not support the session storage")), s ? this[r](a, {
              headers: {
                "X-CSRF-Token": $("body").data("csrftoken")
              },
              success: n,
              error: i,
              payload: e.payload ? e.payload : {}
            }) : ("function" == typeof e.success && e.success(o), o));
          }, this)(e);
        }, e;
      }())();
    }();
  }, {
    "../config/Config.js": 12,
    "../util/Promise.js": 31
  }],
  6: [function (e, t, o) {
    var i = e("./AjaxService.js"),
      s = e("../Feedback.js");
    t.exports = function () {
      var e = function e() {};
      return e.prototype = {
        fetch: function fetch() {
          return console.log(s), i.call({
            type: "get",
            url: "simID?sim=" + s.app.sim,
            cache: !0
          }).then(function (e) {
            return 0 === +e.simExists ? (s.app.anyServiceFailed = !0, console.error("Sim doesn't exsist.")) : s.app.set({
              simId: +e.simID
            }), e;
          }).fail(function (e) {
            console.error("Request couldn't be completed.", e), s.app.anyServiceFailed = !0;
          });
        }
      }, new e();
    }();
  }, {
    "../Feedback.js": 1,
    "./AjaxService.js": 5
  }],
  7: [function (e, t, o) {
    var i = e("./AjaxService.js"),
      s = e("../Feedback.js");
    t.exports = function () {
      var e = function e() {};
      return e.prototype.fetch = function () {
        return i.call({
          type: "get",
          url: "surveyID?survey=" + s.app.survey,
          cache: !0
        }).then(function (e) {
          return 0 === +e.surveyExists ? (s.app.anyServiceFailed = !0, console.error("Survey doesn't exsist.")) : s.app.set({
            surveyId: +e.surveyID
          }), e;
        }).fail(function (e) {
          console.error("Request couldn't be completed.", e), s.app.anyServiceFailed = !0;
        });
      }, new e();
    }();
  }, {
    "../Feedback.js": 1,
    "./AjaxService.js": 5
  }],
  8: [function (e, t, o) {
    var i = e("./AjaxService.js"),
      s = e("../Feedback.js");
    t.exports = function () {
      var e = function e() {};
      return e.prototype.fetch = function (e) {
        if (s.app.isSimIdSurveyId()) return i.call({
          type: "get",
          url: "user/" + s.app.userId + "/survey",
          cache: !0
        }).then(function (e) {
          0 != e.surveyDetails.length ? s.app.questionsJSON = e : s.app.anyServiceFailed = !0;
        }).fail(function (e) {
          console.log("Request couldn't be completed.", e), s.app.anyServiceFailed = !0;
        });
      }, new e();
    }();
  }, {
    "../Feedback.js": 1,
    "./AjaxService.js": 5
  }],
  9: [function (e, t, o) {
    var i = e("./AjaxService.js"),
      s = e("../Feedback.js");
    t.exports = function () {
      var e = function e() {
        this.submit = bind(this.submit, this);
      };
      return e.prototype = {
        submit: function submit(e) {
          return i.call({
            type: "post",
            url: "user/" + s.app.userId + "/survey",
            payload: e
          }).then(function (e) {
            console.log("onSuccessfulSubmit"), "success" === e.status ? (s.app.showAsPopup && s.app.remove(), s.app.isFeedbackCompletedFlag = !0, s.app.onSuccessfulSubmit()) : (s.app.isFeedbackCompletedFlag = !1, s.app.submitFailedFlag = !0, s.app.onSuccessfulSubmit(), s.app.showAsPopup && s.app.remove());
          }).fail(function (e) {
            console.error("Request couldn't be completed.", e), s.app.anyServiceFailed = !0, s.app.isFeedbackCompletedFlag = !1, s.app.submitFailedFlag = !0, s.app.onSuccessfulSubmit();
          });
        }
      }, new e();
    }();
  }, {
    "../Feedback.js": 1,
    "./AjaxService.js": 5
  }],
  10: [function (e, t, o) {
    var i = e("./AjaxService.js"),
      s = e("../Feedback.js"),
      n = function n(e) {
        for (key in e) if (null == s.app[e[key]]) return !1;
        return !0;
      };
    t.exports = function () {
      var e = function e() {
        this.sync = bind(this.sync, this), this.preparePayload = bind(this.preparePayload, this);
      };
      return e.prototype = {
        preparePayload: function preparePayload() {
          var e = {
            surveyId: s.app.surveyId,
            simId: s.app.simId
          };
          return console.log("feedback app", s.app), n(["uliId", "groupId"]) ? (e.uliId = s.app.uliId, e.groupId = s.app.groupId) : n(["courseId", "sectionId", "alUserId", "domain", "email", "courseLabel", "courseName"]) ? (e.courseId = s.app.courseId, e.sectionId = s.app.sectionId, e.alUserId = s.app.alUserId, e.domain = s.app.domain, e.email = s.app.email, e.courseLabel = s.app.courseLabel, e.courseName = s.app.courseName, e.fullName = s.app.aktivLearnUserFullName ? s.app.aktivLearnUserFullName : "") : e.simUserId = s.app.simUserId, e;
        },
        sync: function sync(e) {
          var t = this.preparePayload();
          for (key in e) t[key] = e[key];
          return i.call({
            type: "post",
            url: "user/sync",
            payload: t
          }).then(function (e) {
            e.userID || (console.error("Didn't get the user id."), s.app.anyServiceFailed = !0), s.app.set({
              userId: +e.userID
            }), e.simUserID && e.simUserID > 0 && s.app.set({
              simUserId: +e.simUserID
            }), e.simID && e.simID > 0 && s.app.set({
              simId: +e.simID
            }), e.surveyID && e.surveyID > 0 && s.app.set({
              surveyId: +e.surveyID
            }), e.groupId && e.groupId > 0 && s.app.set({
              groupId: +e.groupId
            }), e.uliId && e.uliId > 0 && s.app.set({
              uliId: +e.uliId
            }), e.aktivLearnUserId && e.aktivLearnUserId > 0 && s.app.set({
              alUserId: +e.aktivLearnUserId
            }), e.courseId && e.courseId > 0 && s.app.set({
              courseId: +e.courseId
            }), e.sectionId && e.sectionId > 0 && s.app.set({
              sectionId: +e.sectionId
            }), e.courseName && s.app.set({
              courseName: e.courseName
            }), e.courseLabel && s.app.set({
              courseLabel: e.courseLabel
            }), e.aktivLearnUserEmail && s.app.set({
              email: e.aktivLearnUserEmail
            }), e.aktivLearnDomain && s.app.set({
              domain: e.aktivLearnDomain
            }), e.fullName && s.app.set({
              aktivLearnUserFullName: e.fullName
            }), s.app.isFeedbackCompletedFlag = 1 == e.feedbackStatus;
          }).fail(function (e) {
            console.error("Request couldn't be completed.", e), s.app.anyServiceFailed = !0;
          });
        }
      }, new e();
    }();
  }, {
    "../Feedback.js": 1,
    "./AjaxService.js": 5
  }],
  11: [function (e, t, o) {
    t.exports = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      smileyActiveUrl: "assets/icons/smileySelected.png",
      smileyResponseUrl: "assets/icons/smiley_response.png",
      smileyErrorUrl: "assets/icons/smiley_error.png"
    }, "smileyActiveUrl", "assets/icons/smileySelected.png"), "smileyInactiveUrl", "assets/icons/smileyUnselected.png"), "heartActiveUrl", "assets/icons/heartSelected.png"), "heartInactiveUrl", "assets/icons/heartUnselected.png"), "starActiveUrl", "assets/icons/starSelected.png"), "starInactiveUrl", "assets/icons/starUnselected.png"), "transparentUrl", "assets/icons/Transparent.gif"), "fontUrl", "assets/fonts/ROBOTO/Roboto-Regular-webfont.woff"), "closeFeedbackButtonUrl", "assets/icons/closeFeedbackButton.png"), "knolskapeLogoUrl", "assets/icons/KNOLSKAPE-logo.png");
  }, {}],
  12: [function (e, t, o) {
    var i = e("./ConfigLocal.js"),
      s = e("./ConfigLive.js"),
      n = e("./ConfigTest.js"),
      r = e("./CommonConfig.js");
    t.exports = function () {
      var e = function e() {
          this.env = "test";
        },
        t = {};
      return e.prototype = {
        environment: function environment(e) {
          this.env = e, this.compute();
        },
        compute: function compute() {
          for (key in r) t[key] = r[key];
          var e = {};
          "local" == this.env && (e = i), "live" == this.env && (e = s), "test" == this.env && (e = n);
          for (key in e) t[key] = e[key];
        },
        set: function set(e, t) {
          switch (this.env) {
            case "local":
              i[e] = t;
              break;
            case "test":
              n[e] = t;
              break;
            case "live":
              s[e] = t;
              break;
            default:
              r[e] = t;
          }
          return this;
        },
        getConfig: function getConfig() {
          return this.compute(), t;
        }
      }, new e();
    }();
  }, {
    "./CommonConfig.js": 11,
    "./ConfigLive.js": 13,
    "./ConfigLocal.js": 14,
    "./ConfigTest.js": 15
  }],
  13: [function (e, t, o) {
    t.exports = {
      apiBaseUrl: "https://feedback.knolskape.com/",
      baseUrl: "https://feedback.knolskape.com/"
    };
  }, {}],
  14: [function (e, t, o) {
    t.exports = {
      apiBaseUrl: "http://localhost/feedback/public/",
      baseUrl: "http://localhost/feedback/public/"
    };
  }, {}],
  15: [function (e, t, o) {
    t.exports = {
      apiBaseUrl: "https://feedback-test.knolskape.com/",
      baseUrl: "https://feedback-test.knolskape.com/"
    };
  }, {}],
  16: [function (e, t, o) {
    t.exports = '<div id="fwc-questionID-<%=questionID%>" class="question-single"><h4><%= qNo %>.&nbsp;<%=question%><% if ( +questionOptional === 0 ) {%><sup><span class="glyphicon glyphicon-asterisk mandatory-questions"></span></sup><% } %></h4><span id="error-<%=questionID%>" class="with-errors hidden madatory-error-message-field">Please fill out this field.</span><div class="input-group question-responses row center-block"><textarea class="form-control comment-area" id="questionID-<%=questionID%>-response" rows="3"></textarea></div></div>';
  }, {}],
  17: [function (e, t, o) {
    t.exports = '<div class="fwc-feedback-already-done" style="text-align:center;position:fixed;top:40%;left:50%;transform:translate(-50%,-50%);padding:30px;border:2px #000 solid;background-color:#FFF"><h2 style="padding-bottom:20px"><%= feedbackDoneHeading %><img class="prevent-drag" src="<%= simleyResponseUrl %>"></h2><h5><%= feedbackDoneSubHeading %></h5></div>';
  }, {}],
  18: [function (e, t, o) {
    t.exports = '<div class="fwc-feedback-already-done-overlay" style="position:relative;position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.6);z-index:999999"><div class="fwc-sim-end-msg-container"></div></div>';
  }, {}],
  19: [function (e, t, o) {
    t.exports = '<div class="fwc-feedback-fetch-issue-overlay" style="position:relative;position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.6);z-index:999999"><div class="fwc-sim-end-msg-container"></div></div>';
  }, {}],
  20: [function (e, t, o) {
    t.exports = '<div class="fwc-feedback-fetch-issue" style="text-align:center;position:fixed;top:40%;left:50%;transform:translate(-50%,-50%);padding:30px;border:2px #000 solid;background-color:#FFF"><h2 style="padding-bottom:20px"><%= feedbackFetchIssueHeading %><img class="prevent-drag" src="<%= smileyErrorUrl%>"></h2></div>';
  }, {}],
  21: [function (e, t, o) {
    t.exports = '<div id="fwc-questionID-<%=questionID%>" class="question-single"><h4><%= qNo %>.&nbsp;<%=question%><% if ( +questionOptional === 0 ) {%><sup><span class="glyphicon glyphicon-asterisk mandatory-questions"></span></sup><% } %></h4><span id="error-<%=questionID%>" class="with-errors hidden madatory-error-message-field">Please fill out this field.</span><div class="form-group checkbox question-responses"><table class="option-select-table"><% for (var i=0; i<options.length; i++) { %><% if(i%2 === 0) { %><tr><% } %><td><span><label class="inline label-control"><input type="checkbox" data-optionid="<%= options[i].optionID %>" id="option-<%=options[i].optionID%>-questionID-<%=questionID%>" name="questionID-<%=questionID%>"><%=options[i].option%></label></span></td><% } %></tr></table></div></div>';
  }, {}],
  22: [function (e, t, o) {
    t.exports = '<style>@font-face{font-family:Roboto;src:url("<%= fontUrl %>") format("woff");font-weight:400;font-style:normal}.container-popup{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.8);z-index:99999}.container-popup *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.hidden{display:none}.popup{width:100%;position:absolute;top:0;left:0}#fwc-logo{left:17px;position:absolute;height:70px;width:70px;margin-top:10px}.fwc-header-text{color:#FFF;font-family:open-sans-serif;text-align:left;margin-left:100px;position:relative;margin-top:25px}#fwc-feedbackHeader{text-align:center;width:100%;padding-left:4px;padding-top:8px}#fwc-closeFeedback{float:right;margin-right:5px;cursor:pointer;display:block;height:20px;width:20px}.fwc-feedback-form-wrapper{overflow-y:auto;padding:10px;background-color:#FFF;height:90%;font-family:Roboto;text-align:left}.center-button{min-height:60px;text-align:center}.star{width:24px;height:24px;background:url("<%= starInactiveUrl %>");cursor:pointer}.starActive{background-image:url("<%= starActiveUrl %>");width:24px;height:24px;border-style:none;cursor:pointer}.heart{width:24px;height:24px;background:url("<%= heartInactiveUrl %>");cursor:pointer}.heartActive{background-image:url("<%= heartActiveUrl %>");width:24px;height:24px;border-style:none;cursor:pointer}.smiley{width:24px;height:24px;background:url("<%= smileyInactiveUrl%>");cursor:pointer}.smileyActive{background-image:url("<%= smileyActiveUrl %>");width:24px;height:24px;border-style:none;cursor:pointer}.mandatory-questions{color:red;font-size:10px}.madatory-error-message-field{font-size:13px;color:red;padding-left:26px}.submit-button-error-message{position:relative;width:100%}.comment-area{background-color:transparent}.inline{font-size:16px}#fwc-submit{font-size:19px;font-family:Roboto,serif;padding-left:30px;padding-right:30px;height:40px;background-color:#E79941;border:0;margin-top:10px}.question-responses{padding-left:30px;padding-top:10px;width:100%}.option-select-table td{padding-right:30px;padding-bottom:5px;max-width:250px;word-wrap:break-word;vertical-align:top}.question-single{padding:10px}#fwc-mandatory-message{position:absolute;top:0;width:100%;text-align:center;z-index:999999999999;display:none}#fwc-mandatory-message-text{color:<%=mandatoryMessageFontColor %>;background-color:<%=mandatoryMessageBackgroundColor %>;padding-left:10px;padding-right:10px;padding-bottom:2px;font-family:Roboto;font-size:20px}</style>';
  }, {}],
  23: [function (e, t, o) {
    t.exports = '<style>@font-face{font-family:Roboto;src:url("<%= fontUrl %>") format("woff");font-weight:400;font-style:normal}.container-popup{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.8);z-index:99999}.container-popup *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.hidden{display:none}.popup{width:50%;height:80%;position:absolute;top:2%;left:25%;width:50%;height:80%;position:absolute;top:2%;left:25%}#fwc-logo{left:17px;position:absolute;height:70px;width:70px;margin-top:10px}.fwc-header-text{color:#FFF;font-family:open-sans-serif;text-align:left;margin-left:100px;position:relative;margin-top:25px}#fwc-feedbackHeader{text-align:center;width:100%;padding-left:4px;padding-top:8px}#fwc-closeFeedback{float:right;margin-right:5px;cursor:pointer;display:block;height:20px;width:20px}.fwc-feedback-form-wrapper{overflow-y:auto;padding:10px;background-color:#FFF;height:90%;font-family:Roboto;text-align:left}.center-button{min-height:60px;text-align:center}.star{width:24px;height:24px;background:url("<%= starInactiveUrl %>");cursor:pointer}.starActive{background-image:url("<%= starActiveUrl %>");width:24px;height:24px;border-style:none;cursor:pointer}.heart{width:24px;height:24px;background:url("<%= heartInactiveUrl %>");cursor:pointer}.heartActive{background-image:url("<%= heartActiveUrl %>");width:24px;height:24px;border-style:none;cursor:pointer}.smiley{width:24px;height:24px;background:url("<%= smileyInactiveUrl%>");cursor:pointer}.smileyActive{background-image:url("<%= smileyActiveUrl %>");width:24px;height:24px;border-style:none;cursor:pointer}.mandatory-questions{color:red;font-size:10px}.madatory-error-message-field{font-size:13px;color:red;padding-left:26px}.submit-button-error-message{position:relative;background-color:#dfdfdf;width:100%}.comment-area{background-color:transparent}.inline{font-size:16px}#fwc-submit{font-size:19px;font-family:Roboto,serif;padding-left:30px;padding-right:30px;height:40px;background-color:#E79941;border:0;margin-top:10px}.question-responses{padding-left:30px;padding-top:10px;width:100%}.option-select-table td{padding-right:30px;padding-bottom:5px;max-width:250px;word-wrap:break-word;vertical-align:top}.question-single{padding:10px}#fwc-mandatory-message{position:absolute;top:0;width:100%;text-align:center;z-index:999999999999;display:none}#fwc-mandatory-message-text{color:<%=mandatoryMessageFontColor %>;background-color:<%=mandatoryMessageBackgroundColor %>;padding-left:10px;padding-right:10px;padding-bottom:2px;font-family:Roboto;font-size:20px}</style>';
  }, {}],
  24: [function (e, t, o) {
    t.exports = '<div id="fwc-questionID-<%=questionID%>" class="question-single"><h4><%= qNo %>.&nbsp;<%=question%><% if ( +questionOptional === 0 ) {%><sup><span class="glyphicon glyphicon-asterisk mandatory-questions"></span></sup><% } %></h4><span id="error-<%=questionID%>" class="with-errors hidden madatory-error-message-field">Please fill out this field.</span><div class="form-group question-responses"><% for (var i=0; i<5; i++) { %><img id="rating<%=(i+1)%>-<%=questionID%>" class="prevent-drag <% if(questionType == 3) { %> star <% } else { if(questionType == 5) { %> heart <% } else { %> smiley <% } %> <% } %>" src="<%= transparentUrl %>"><% } %></div></div>';
  }, {}],
  25: [function (e, t, o) {
    t.exports = '<div class="fwc-sim-end-msg" style="text-align:center;position:fixed;top:40%;left:50%;transform:translate(-50%,-50%);padding:30px;border:2px #000 solid;background-color:#FFF"><h2 style="padding-bottom:20px"><%= popupHeading %></h2><h5><%= popupSubHeading %></h5></div>';
  }, {}],
  26: [function (e, t, o) {
    t.exports = '<div class="fwc-sim-end-popup" style="position:relative;position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.6);z-index:999999"><div class="fwc-sim-end-msg-container"></div></div>';
  }, {}],
  27: [function (e, t, o) {
    t.exports = '<div id="fwc-questionID-<%=questionID%>" class="question-single"><h4><%= qNo %>.&nbsp;<%=question%><% if ( +questionOptional === 0 ) {%><sup><span class="glyphicon glyphicon-asterisk mandatory-questions"></span></sup><% } %></h4><span id="error-<%=questionID%>" class="with-errors hidden madatory-error-message-field">Please fill out this field.</span><div class="form-group radio question-responses"><table class="option-select-table"><% for (var i=0; i < options.length; i++) { %><% if(i%3 === 0) { %><tr><% } %><td><span><label class="inline label-control"><input type="radio" data-optionid="<%= options[i].optionID %>" id="option-<%=options[i].optionID%>-questionID-<%=questionID%>" name="questionID-<%=questionID%>"><%=options[i].option%></label></span></td><% } %></tr></table></div></div>';
  }, {}],
  28: [function (e, t, o) {
    t.exports = '<div class="submit-button-error-message"><div class="center-button"><input id="fwc-submit" class="btn btn-info" type="button" value="Submit"></div></div>';
  }, {}],
  29: [function (e, t, o) {
    t.exports = '<div id="fwc-feedbackComponent"><div class="container-popup"><div class="popup"><div id="fwc-feedbackHeader" style="background:<%=headerColor %>"><div id="fwc-mandatory-message"><span id="fwc-mandatory-message-text"><%= mandatoryMessage %></span></div><img class="prevent-drag" id="fwc-closeFeedback" src="<%=closeFeedbackButton%>"> <img class="prevent-drag" src="<%=knolskapeLogoUrl%>" id="fwc-logo"><div class="fwc-header-text" style="font-size:<%=headerTitleFontSize %>;color:<%=headerTitleColor %>"><%= headerTitle %></div><br></div><div class="fwc-feedback-form-wrapper"></div></div></div></div><img class="prevent-drag hidden" src="<%= smileyActiveUrl %>"> <img class="prevent-drag hidden" src="<%= heartActiveUrl %>"> <img class="prevent-drag hidden" src="<%= starActiveUrl %>">';
  }, {}],
  30: [function (e, t, o) {
    t.exports = function () {
      var e = function e() {};
      return e.prototype.bind = function (e, t) {
        return function () {
          return e.apply(t, arguments);
        };
      }, window.bind = new e().bind, new e();
    }();
  }, {}],
  31: [function (e, t, o) {
    var i = function () {
      function e() {
        this.getPromiseFun = bind(this.getPromiseFun, this);
      }
      return e.prototype.getPromiseFun = function (e, t) {
        var o, i, s;
        return o = $.Deferred(), i = o.promise(), "function" != typeof e && o.reject("Expected function for promise"), s = function s() {
          var s, n;
          try {
            return n = e.apply(t, arguments), $.when(n).fail(function (e) {
              return o.reject(e);
            });
          } catch (r) {
            return s = r, o.reject(s), i;
          }
        };
      }, e;
    }();
    t.exports = new i();
  }, {}],
  32: [function (e, t, o) {
    t.exports = function () {
      var e = function e() {
        this.tmpl = bind(this.tmpl, this);
      };
      return e.prototype.tmpl = function (e, t) {
        var o = {},
          i = /\W/.test(e) ? new Function("obj", "var p=[],print=function(){p.push.apply(p,arguments);};with(obj){p.push('" + e.replace(/[\r\t\n]/g, " ").split("<%").join("\t").replace(/((^|%>)[^\t]*)'/g, "$1\r").replace(/\t=(.*?)%>/g, "',$1,'").split("\t").join("');").split("%>").join("p.push('").split("\r").join("\\'") + "');}return p.join('');") : o[e] = o[e] || tmpl(document.getElementById(e).innerHTML);
        return t ? i(t) : i;
      }, new e();
    }();
  }, {}],
  33: [function (e, t, o) {
    t.exports = function () {
      var e = function e() {
        this.toType = bind(this.toType, this), this.areOfSameType = bind(this.areOfSameType, this);
      };
      return e.prototype = {
        toType: function toType(e) {
          return {}.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
        },
        areOfSameType: function areOfSameType(e, t) {
          return this.toType(e) == this.toType(t);
        }
      }, new e();
    }();
  }, {}],
  34: [function (e, t, o) {
    var i = e("./TypeChecker.js").areOfSameType,
      s = e("../config/Config.js").getConfig();
    t.exports = function () {
      var e = function e() {
          this.build = bind(this.build, this), this.getUrl = bind(this.getUrl, this);
        },
        t = function t(e) {
          i(e[0], []) && (e = e[0]);
          var t = {
            urlParams: [],
            queryParams: {}
          };
          return e.forEach(function (e) {
            if (i(e, {})) for (key in e) t.queryParams[key] = e[key];else e += "", e = e.replace(/(^[\/ ]+)|([\/ ]+$)/g, ""), t.urlParams.push(e);
          }), t;
        };
      return e.prototype.getUrl = function () {
        return args = Array.prototype.slice.call(arguments), i(args[0], []) && (args = args[0]), args.unshift(s.baseUrl), this.build(args);
      }, e.prototype.build = function () {
        args = Array.prototype.slice.call(arguments);
        var e = t(args),
          o = "";
        e.urlParams.forEach(function (e) {
          o += e + "/";
        }), o = o.replace(/\/$/, "");
        var i = Object.keys(e.queryParams);
        if (0 == i.length) return o;
        if (o += "?", key in e.queryParams) {
          var s = e.queryParams[key];
          o += key + "=" + s + ",";
        }
        return o = o.replace(/,$/, "");
      }, new e();
    }();
  }, {
    "../config/Config.js": 12,
    "./TypeChecker.js": 33
  }],
  35: [function (e, t, o) {
    var i = window.typeChecker = e("../util/TypeChecker.js");
    t.exports = function () {
      var e = function e() {
          this.isAttributeValid = bind(this.isAttributeValid, this);
        },
        t = {
          sim: [""],
          simId: [1],
          survey: [""],
          surveyId: [1],
          env: [""],
          headerColor: [""],
          headerTitleColor: [""],
          headerSubTitleColor: [""],
          headerSubTitleHighlightColor: [""],
          headerTitle: [""],
          headerSubTitle: [""],
          headerTitleFontSize: [""],
          headerSubTitleFontSize: [""],
          headerSubTitleHighlightTimeout: [""],
          userId: [1],
          simUserId: [1],
          showAsPopup: [!0],
          isFeedbackFetchedFlag: [!0],
          questionsHTML: [""],
          isFeedbackCompletedFlag: [!0],
          popupHeading: [""],
          popupSubHeading: [""],
          popupTimeout: [123],
          feedbackDoneHeading: [""],
          feedbackDoneSubHeading: [""],
          feedbackFetchIssueHeading: [""],
          feedbackAlreadyGivenPopupTimeout: [123],
          feedbackFetchIssuePopupTimeout: [123],
          isSurveyMandatory: [!0],
          mandatoryMessage: [!0],
          mandatoryMessageFontColor: [""],
          mandatoryMessageBackgroundColor: [""],
          submitFailedFlag: [1, !0],
          courseId: [1],
          sectionId: [1],
          alUserId: [1],
          domain: [""],
          email: [""],
          courseLabel: [""],
          courseName: [""],
          uliId: [1],
          groupId: [1],
          aktivLearnUserFullName: [""],
          onReadyFun: [function () {}]
        };
      return e.prototype.isAttributeValid = function (e, o) {
        if (t[e]) {
          var s = !1;
          if (t[e].forEach(function (e) {
            s = s || i.areOfSameType(e, o);
          }), s) return !0;
        }
        return console.error("Invalid property trying to be set."), !1;
      }, new e();
    }();
  }, {
    "../util/TypeChecker.js": 33
  }]
}, {}, [1]);